import MailchimpForm from "../components/MailchimpForm";
import subscribePopup from "../components/subscribePopup";
import toggleLearnMore from '../actions/toggleLearnMore';

/**
 * Front Page
 */
const PageFrontPage = ( $ ) => {

	if ( $( 'body' ).hasClass( 'home' ) ) {
		MailchimpForm( $ );
		toggleLearnMore( $ );
		subscribePopup( $ );
	}

};

export default PageFrontPage;
